<template>
  <div>
    <Modal v-model="userForm" :title="title" width="600" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="110">
       
        <Row>
            <Col span="24">
                <FormItem label="单位名称" prop="companyName" :class="{requireStar:true}" >
                  <Input v-model="formValidate.companyName"  ></Input>
                </FormItem>
            </Col>
        </Row>
         <Row >
            <Col span="24">
                  <FormItem label="类别" prop="category">
                    <RadioGroup v-model="formValidate.category">
                      <Radio label="演出" >演出</Radio>
                      <Radio label="文化" >文化</Radio>
                      <Radio label="旅游" >旅游</Radio>
                      <Radio label="票务">票务</Radio>
                    </RadioGroup>
                  </FormItem>
            </Col>
        </Row>
         <Row>
            <Col span="24">
                <FormItem label="网站地址" prop="companyUrl" >
                  <Input v-model="formValidate.companyUrl"  ></Input>
                </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                  <FormItem label="注册地址" prop="companyAddress" :class="{requireStar:true}">
                    <Input v-model="formValidate.companyAddress"></Input>
                  </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                  <FormItem label="法人" prop="companyCorp" :class="{requireStar:true}">
                    <Input v-model="formValidate.companyCorp" ></Input>
                  </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                  <FormItem label="联系电话" prop="phone" >
                    <Input v-model="formValidate.phone" ></Input>
                  </FormItem>
            </Col>
        </Row>
      </Form>
      <!--自定义按钮，解决自带按钮，点击就关闭的问题-->
      <div slot="footer">
        <Button type="text" size="large" @click="cancle">取消</Button>
        <Button type="primary" size="large" @click="handleSubmit('formValidate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Bus from '@/utils/bus.js'
  export default {
    components:{
    },
    data() {
      return {
        userForm: false,
        title:'',
      
        formValidate: {
          _id: '',
          companyName: '',
          companyAddress: '',
          companyCorp: '',
          phone:'',
          companyUrl:'',
          category:''
        },
        ruleValidate: {
          companyName: [{
            required: true,
            message: '单位名不能为空',
            trigger: 'change'
          }],
         /** companyUrl: [{
            required: true,
            message: '网站地址不能为空',
            trigger: 'change'
          }], */
          companyAddress: [{
            required: true,
            message: '注册地址不能为空',
            trigger: 'change'
          }],
          companyCorp: [{
            required: true,
            message: '法人不能为空',
            trigger: 'change'
          }],
           category: [{
            required: true,
            message: '类型不能为空',
            trigger: 'change'
          }],
        },
      }
    },

    methods: {
      openModal(title,row) {
        this.title =title
        this.userForm = true
        this.handleReset("formValidate");
        if(row!=null){
          this.formValidate=row
        }
      },  
    
      handleSubmit(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            let url =  'api/unit' 
            let myData = {
              type:1,
              _id: this.formValidate._id,
              companyName: this.formValidate.companyName,
              companyAddress: this.formValidate.companyAddress,
              companyCorp: this.formValidate.companyCorp,
              phone: this.formValidate.phone,
              companyUrl: this.formValidate.companyUrl,
              category: this.formValidate.category,
              
            }
            this.req({
              url: url,
              method: 'post',
              data: myData
            }).then(response => {
             if (response.data.code == 200) {
                this.$Message.success(response.data.msg);
                this.$parent.loadPage();
              } else {
                 this.$Message.error(response.data.msg);
              }
              this.userForm = false;
            }).catch(error => {
              this.reponseData = "发生错误，无法显示内容"
            })
          } else {
            return;
          }
        }) 
      },
      handleReset(name) {
         if (this.$refs[name]!==undefined) {
              this.$refs[name].resetFields();
          }
      },
      cancle() {
        this.userForm = false;
      },
    
    },
    mounted() {
    },
  }
</script>
<style>
  /*动态必填项className*/
  .requireStar .ivu-form-item-label:before{
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: #ed4014;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/company/CompanyEdit.vue